import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';

/**
 *　発注メモの削除を行うユースケース
 */
export class DeleteOrderMemoUseCase {
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   * 発注メモを更新する
   * @param orderId - 発注ID
   */
  public async Execute(orderId: string): Promise<INetworkResult<undefined, IError>> {
    try {
      const response = await this.repository.deleteOrderMemo(orderId);
      switch (response.status.type) {
        case 'success':
          break;
        case 'error':
          return {
            status: {
              type: 'error',
              error: response.status.error,
            },
          };
        default:
          throw new Error('Invalid status');
      }

      return {
        status: {
          type: 'success',
          data: undefined,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
